import React, { useState, useEffect } from 'react';
import useToken from '../../App/useToken';
import { Button, Modal, Form, Col, Row } from 'react-bootstrap';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import StudentService from '../../service/studentService'
import UserCreateModal from '../../components/UserCreateModal/UserCreateModal';
import UserService from '../../service/userService'
import MajorCourseService from '../../service/majorCourseService'
import StudentTable from '../../components/StudentTable/StudentTable';
import UserTable from '../../components/UserTable/UserTable';
import MajorCourseTable from '../../components/MajorCourseTable/MajorCourseTable';
import './Admin.css'

export default function AdminDashboard() {
  const [students, setStudents] = useState([]);
  const [users, setUsers] = useState([]);
  const [showAddUsermModal, setShowAddUsermModal] = useState(false);
  const [majorCourseBasics, setMajorCourseBasics] = useState([]);
  const [majorCourseFinals, setMajorCourseFinals] = useState([]);
  const [ranks, setRanks] = useState([])
  const { getToken, isAdmin } = useToken();
  const token = getToken();
  const isUserAdmin = isAdmin();

  const getStudent = async () => {
    const studentService = new StudentService();
    const res = await studentService.getStudent(token);
    if(res) setStudents(res);
  }

  const getMajorCourse = async () => {
    const majorCourseService = new MajorCourseService();
    const res = await majorCourseService.getMajorCourse(token);
    if(res) {
      setMajorCourseBasics(res.basic);
      setMajorCourseFinals(res.final);
    }
  }

  const getUser = async () => {
    const userService = new UserService();
    const res = await userService.getUser(token);
    if(res) setUsers(res);
  }

  useEffect(() => {
    getUser();
    getStudent();
    getMajorCourse();
  }, []);
  return(
    <div className='admin-container'>
      <UserCreateModal
        showAddUsermModal={showAddUsermModal}
        setShowAddUsermModal={setShowAddUsermModal}
        getUser={getUser}
      />
      { isUserAdmin &&
        <div className='add-admin-container'>
          <a 
            className="btn btn-outline-success btn-sm btn-creat-course" 
            onClick={() => setShowAddUsermModal(true)}
          >
            เพิ่มผู้ดูแลระบบ
          </a>
        </div>
      }
      <div className="course-list">
        <Tabs className='admin-react-tabs'>
            <TabList>
                <Tab key='user'><span>ผู้ดูแลทั้งหมด({users.length})</span></Tab>
                <Tab key='student'><span>ผู้มีสิทธิเรียนทั้งหมด({students.length})</span></Tab>
                <Tab key='majorCourseBasic'><span>หลักสูตรขั้นต้น({majorCourseBasics.length})</span></Tab>
                <Tab key='majorCourseFinal'><span>หลักสูตรขั้นปลาย({majorCourseFinals.length})</span></Tab>
            </TabList>
            <TabPanel key='user'>
              <UserTable users={users} getUser={getUser} majorCourseBasic={majorCourseBasics} majorCourseFinal={majorCourseFinals} />
            </TabPanel>
            <TabPanel key='student'>
              <StudentTable students={students} />
            </TabPanel>
            <TabPanel key='majorCourseBasic'>
              <MajorCourseTable majorCourses={majorCourseBasics} getMajorCourse={getMajorCourse} />
            </TabPanel>
            <TabPanel key='majorCourseFinal'>
              <MajorCourseTable majorCourses={majorCourseFinals} getMajorCourse={getMajorCourse} />
            </TabPanel>
          </Tabs>
      </div>
    
    </div>
  )
}
